var registerComponent = require('../core/component').registerComponent;
var THREE = require('../lib/three');

/**
 * Camera component.
 * Pairs along with camera system to handle tracking the active camera.
 */
module.exports.Component = registerComponent('camera', {
  schema: {
    active: { default: true },
    far: { default: 10000 },
    fov: { default: 80, min: 0 },
    near: { default: 0.005, min: 0 },
    spectator: { default: false },
    zoom: { default: 1, min: 0 }
  },

  /**
   * Initialize three.js camera and add it to the entity.
   * Add reference from scene to this entity as the camera.
   */
  init: function() {
    var camera;
    var el = this.el;

    // Create camera.
    camera = this.camera = new THREE.PerspectiveCamera();
    el.setObject3D('camera', camera);
    //  if the dummy 3dmodel is present inside the light make it invisible
    //  check for inspector available
    const modelUrl = 'https://hatchxr.s3.amazonaws.com/hatch+camera.gltf';
    const prevModel = this.el.querySelector(
      `[gltf-model='https://hatchxr.s3.amazonaws.com/hatch+camera.gltf']`
    );
    if (prevModel && !prevModel.hasAttribute('dummyModel')) {
      prevModel.parentElement.removeChild(prevModel);
    }
    let dummyModel = this.el.querySelector(`[dummyModel]`);
    //  inject the 3DModel if its not available
    if (!dummyModel) {
      dummyModel = document.createElement('a-entity');
      this.el.appendChild(dummyModel);
    }
    dummyModel.setAttribute('dummyModel', '');
    dummyModel.setAttribute('data-not-visible', true);
    dummyModel.setAttribute('scale', '0.75 0.75 0.75');
    dummyModel.setAttribute('rotation', '0 180 0');
    dummyModel.setAttribute('data-not-selectable', true);
    dummyModel.setAttribute('visible', false);
    if (!this.el.dataset.hideDummyModel) {
      if (this.el.dataset.hideModel) {
        dummyModel.setAttribute('visible', false);
      } else if (window.AFRAME.INSPECTOR && window.AFRAME.INSPECTOR.opened) {
        /**
         * make the visibility of the model true */
        dummyModel.setAttribute('gltf-model', modelUrl);
        dummyModel.setAttribute('visible', true);

        dummyModel.components['gltf-model'].data = '';
        dummyModel.components['gltf-model'].attrValue = '';
      } else {
        //  find the 3DModel inside and make it visible
        window.addEventListener('INSPECTOR_INJECTED', () => {
          dummyModel.setAttribute('gltf-model', modelUrl);
          dummyModel.setAttribute('visible', true);
          dummyModel.components['gltf-model'].data = '';
          dummyModel.components['gltf-model'].attrValue = '';
        });
      }
    }
  },

  /**
   * Update three.js camera.
   */
  update: function(oldData) {
    var data = this.data;
    var camera = this.camera;

    // Update properties.
    camera.aspect = data.aspect || window.innerWidth / window.innerHeight;
    camera.far = data.far;
    camera.fov = data.fov;
    camera.near = data.near;
    camera.zoom = data.zoom;
    camera.updateProjectionMatrix();

    this.updateActiveCamera(oldData);
    this.updateSpectatorCamera(oldData);
  },

  updateActiveCamera: function(oldData) {
    var data = this.data;
    var el = this.el;
    var system = this.system;
    var inspectorActive = false;
    if (AFRAME.INSPECTOR && AFRAME.INSPECTOR.inspectorActive) {
      inspectorActive = true;
    }
    // Active property did not change.
    if (
      (oldData && oldData.active === data.active) ||
      data.spectator ||
      inspectorActive
    ) {
      return;
    }

    // If `active` property changes, or first update, handle active camera with system.
    if (data.active && system.activeCameraEl !== el) {
      // Camera enabled. Set camera to this camera.
      system.setActiveCamera(el);
    } else if (!data.active && system.activeCameraEl === el) {
      // Camera disabled. Set camera to another camera.
      system.disableActiveCamera();
    }
  },

  updateSpectatorCamera: function(oldData) {
    var data = this.data;
    var el = this.el;
    var system = this.system;
    // spectator property did not change.
    if (oldData && oldData.spectator === data.spectator) {
      return;
    }

    // If `spectator` property changes, or first update, handle spectator camera with system.
    if (data.spectator && system.spectatorCameraEl !== el) {
      // Camera enabled. Set camera to this camera.
      system.setSpectatorCamera(el);
    } else if (!data.spectator && system.spectatorCameraEl === el) {
      // Camera disabled. Set camera to another camera.
      system.disableSpectatorCamera();
    }
  },

  /**
   * Remove camera on remove (callback).
   */
  remove: function() {
    this.el.removeObject3D('camera');
  }
});
